import React from 'react';
import {
  Button, Modal, ModalBody, ModalFooter,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

const PopupModal = ({
  content, action, cancel, id, isModalOpen, setModalOpen,
}) => (
  <Modal open={isModalOpen} onClose={() => setModalOpen(false)} id={id}>
    <ModalBody className="text-align-center pad-2-tb">
      <p className="legal-1">{content}</p>
    </ModalBody>
    <ModalFooter>
      <Button className="margin-1-t" styleType="secondary" onClick={cancel}>Stay</Button>
      <Button styleType="primary" onClick={action}>Leave</Button>
    </ModalFooter>
  </Modal>
);

export default PopupModal;

PopupModal.propTypes = {
  content: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  setModalOpen: PropTypes.func.isRequired,
};
